export default __webpack_public_path__ + "static/media/seminarNodata.6a9e48c6.png";